import React, { Component } from 'react';

import classnames from 'classnames';
import { Typography } from '@mui/material';

import { WithStyles, withStyles } from '@mui/styles';

import APLabelStyles from './styles/APLabel.style';

interface APLabelProps extends WithStyles<typeof APLabelStyles> {
  children: React.ReactNode;
  className?: string
}

class APLabel extends Component<APLabelProps, {}> {
  render() {
    const {
      classes,
      className,
      children
    } = this.props;

    const containerCls = classnames(className, classes.labelContainer);

    return (
      <Typography className={containerCls} variant="body1">
        {children}
      </Typography>
    );
  }
}

export default withStyles(APLabelStyles)(APLabel);
